export const conversationUIFlagsGetter = _state => conversationUuid => {
  return _state.uiFlags[conversationUuid] || { isFetching: false };
};

export const conversationRecordStatusGetter = _state => conversationUuid => {
  return _state.recordStatus[conversationUuid] || 'unknown';
};

export const conversationStatusMutations = {
  SET_UI_FLAG(currentState, { conversationUuid, uiFlags }) {
    currentState.uiFlags = {
      ...currentState.uiFlags,
      [conversationUuid]: {
        ...(currentState.uiFlags[conversationUuid] || {}),
        ...uiFlags,
      },
    };
  },
  SET_RECORD_STATUS(currentState, { conversationUuid, status }) {
    currentState.recordStatus = {
      ...currentState.recordStatus,
      [conversationUuid]: status,
    };
  },
};

export const fetchConversationResource = async (
  { commit, rootGetters },
  { conversationUuid },
  { request, onSuccess }
) => {
  commit('SET_UI_FLAG', { conversationUuid, uiFlags: { isFetching: true } });
  try {
    const store = { getters: rootGetters };
    const data = await request(conversationUuid, store);
    onSuccess(commit, conversationUuid, data);
    commit('SET_RECORD_STATUS', { conversationUuid, status: 'ok' });
  } catch (error) {
    const status = error.response?.status === 400 ? 'absent' : 'error';
    commit('SET_RECORD_STATUS', { conversationUuid, status });
  } finally {
    commit('SET_UI_FLAG', { conversationUuid, uiFlags: { isFetching: false } });
  }
};
